import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone } from 'lucide-react';
const agents = [{
  name: 'Simon Patton',
  photo: 'https://cdn.magicpatterns.com/uploads/kMFVCPy4L14o2QvwaNWFVH/simon_patton_headshot_square.jpg',
  email: 'simon@labensketeam.com',
  phone: '480-577-0008'
}, {
  name: 'Patty LaBenske',
  photo: 'https://cdn.magicpatterns.com/uploads/1WvLBUZnr8f4NYo5reXHDn/patty-headshot_copy.jpg',
  email: 'patty@labensketeam.com',
  phone: '602-625-8470'
}];
export function AgentSection() {
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <span className="text-[#C1694F] font-medium tracking-wider uppercase text-sm mb-2 block" data-id="element-4">
            Your Guides
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D2D2D] mb-4" data-id="element-5">
            Meet Your Listing Agents
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-6">
            Local experts who understand what makes this property special and
            can guide you through every step.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto" data-id="element-7">
          {agents.map((agent, index) => <motion.div key={agent.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="text-center" data-id="element-8">
              <div className="relative w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden shadow-lg" data-id="element-9">
                <img src={agent.photo} alt={agent.name} className="w-full h-full object-cover" data-id="element-10" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#2D2D2D] mb-2" data-id="element-11">
                {agent.name}
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-12">Listing Agent</p>
              <div className="space-y-2" data-id="element-13">
                <a href={`tel:${agent.phone}`} className="flex items-center justify-center text-gray-700 hover:text-[#C1694F] transition-colors" data-id="element-14">
                  <Phone size={16} className="mr-2" data-id="element-15" />
                  {agent.phone}
                </a>
                <a href={`mailto:${agent.email}`} className="flex items-center justify-center text-gray-700 hover:text-[#C1694F] transition-colors" data-id="element-16">
                  <Mail size={16} className="mr-2" data-id="element-17" />
                  {agent.email}
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}